"use client";

import { Button } from "@boostdev/design-system-components/client";
import { cn } from "@boostdev/design-system-components/utils";
import { ChevronLeftIcon } from "@/components/atoms/icons/ChevronLeftIcon";
import { ChevronRightIcon } from "@/components/atoms/icons/ChevronRightIcon";
import css from "./PhotoModalViewer.module.css";

export interface PhotoNavButtonProps {
  readonly direction: "prev" | "next";
  readonly onClick: () => void;
  readonly disabled: boolean;
  readonly label: string;
}

export function PhotoNavButton({
  direction,
  onClick,
  disabled,
  label,
}: PhotoNavButtonProps) {
  const Icon = direction === "prev" ? ChevronLeftIcon : ChevronRightIcon;
  return (
    <Button
      className={cn(css.overlayButton, css[direction])}
      isIconOnly
      onClick={onClick}
      disabled={disabled}
      aria-disabled={disabled}
      aria-label={label}
    >
      <Icon />
    </Button>
  );
}
